var malone_two;
(function($) {
  "use strict";
  malone_two = (function() {
    return {
      init: function() {
        // Collection page
        this.collectionPage();

        // Scripts, effects
        this.lazyImages();

        // Blog masonry
        this.blogMasonry();
      },

      // Collection page
      collectionPage: function() {
        $(".ms-collection .short-description .read-more").on("click", () => {
          $(".ms-collection .short-description").addClass("d-none");
          $(".ms-collection .description").removeClass("d-none");
        });
      },

      // Scripts, effects
      lazyImages: function() {
        function isRetina() {
          return window.devicePixelRatio > 1;
        }

        function isMobile() {
          if($(document).outerWidth() > 767) { return false; } else { return true; }
        }

        $("header .top-center .navbar .navbar-nav li.nav-item .nav-link").hover(function () {
          $(".lazy-img-2").each(function () {
            var element = $(this);
            var src = $(element).attr("data-src");
            if(isRetina() && isMobile() && $(element).attr("data-retina-mobile-src") != undefined) src = $(element).attr("data-retina-mobile-src");
            if(!isRetina() && isMobile() && $(element).attr("data-mobile-src") != undefined) src = $(element).attr("data-mobile-src");
            if(isRetina() && !isMobile() && $(element).attr("data-retina-src") != undefined) src = $(element).attr("data-retina-src");
            if(src == '') src = $(element).attr("data-src");
            $(element).attr("src", src);
            $(element).parent().waitForImages(function() {
              setTimeout(function () {
                $(element).parent().addClass("active");
              }, 100);
            });
          });
        });
      },

      // Blog masonry
      blogMasonry: function() {
        function reloadItems() {
          $("#blog .posts").waitForImages(function() {
            $("#blog .posts").masonry('reloadItems')
          });
        }
        reloadItems();
        $("body").on("click", "#blog #more .button", function() {
          setTimeout(function () {
            reloadItems()
          }, 1000);
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  malone_two.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      malone_two.init();
    }).on('shopify:section:unload', function() {
      malone_two.init();
    }).on('shopify:section:select', function() {
      malone_two.init();
    }).on('shopify:section:deselect', function() {
      malone_two.init();
    }).on('shopify:block:select', function() {
      malone_two.init();
    }).on('shopify:block:deselect', function() {
      malone_two.init();
    });
}

/*! waitForImages jQuery Plugin 2018-02-13 */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){var b="waitForImages",c=function(a){return a.srcset&&a.sizes}(new Image);a.waitForImages={hasImageProperties:["backgroundImage","listStyleImage","borderImage","borderCornerImage","cursor"],hasImageAttributes:["srcset"]},a.expr.pseudos["has-src"]=function(b){return a(b).is('img[src][src!=""]')},a.expr.pseudos.uncached=function(b){return!!a(b).is(":has-src")&&!b.complete},a.fn.waitForImages=function(){var d,e,f,g=0,h=0,i=a.Deferred(),j=this,k=[],l=a.waitForImages.hasImageProperties||[],m=a.waitForImages.hasImageAttributes||[],n=/url\(\s*(['"]?)(.*?)\1\s*\)/g;if(a.isPlainObject(arguments[0])?(f=arguments[0].waitForAll,e=arguments[0].each,d=arguments[0].finished):1===arguments.length&&"boolean"===a.type(arguments[0])?f=arguments[0]:(d=arguments[0],e=arguments[1],f=arguments[2]),d=d||a.noop,e=e||a.noop,f=!!f,!a.isFunction(d)||!a.isFunction(e))throw new TypeError("An invalid callback was supplied.");return this.each(function(){var b=a(this);f?b.find("*").addBack().each(function(){var b=a(this);b.is("img:has-src")&&!b.is("[srcset]")&&k.push({src:b.attr("src"),element:b[0]}),a.each(l,function(a,c){var d,e=b.css(c);if(!e)return!0;for(;d=n.exec(e);)k.push({src:d[2],element:b[0]})}),a.each(m,function(a,c){var d=b.attr(c);return!d||void k.push({src:b.attr("src"),srcset:b.attr("srcset"),element:b[0]})})}):b.find("img:has-src").each(function(){k.push({src:this.src,element:this})})}),g=k.length,h=0,0===g&&(d.call(j),i.resolveWith(j)),a.each(k,function(f,k){var l=new Image,m="load."+b+" error."+b;a(l).one(m,function b(c){var f=[h,g,"load"==c.type];if(h++,e.apply(k.element,f),i.notifyWith(k.element,f),a(this).off(m,b),h==g)return d.call(j[0]),i.resolveWith(j[0]),!1}),c&&k.srcset&&(l.srcset=k.srcset,l.sizes=k.sizes),l.src=k.src}),i.promise()}});
